/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { Cuid } from './cuid'

/**
 * PII 混在フォーム（SURVEYノードの全画面ゲート）の 1 設問ぶんの回答。
questionType により optionIds / freeText / leadValue のいずれかを使う（サーバ側で設問型を解決）。
 */
export interface SurveyFormAnswer {
  /** リード（PII）項目（leadFieldKind 非null）の設問で入力された値。専用テーブルへ隔離保存される */
  leadValue?: string
  /** 自由記述（FREE 設問用）。リード項目の設問では無視 */
  freeText?: string
  /** 選択した選択肢ID。SINGLE=1件 / MULTI=複数 / FREE=空。リード項目の設問では無視 */
  optionIds?: Cuid[]
  /** 回答した設問ID */
  questionId: Cuid
}
